export const USE_CASES = {
    'api-documentation': {
        title: 'InkSpot for API Documentation',
        heroTitle: 'Automate Your API Docs',
        description: 'Stop manually writing endpoints. Let InkSpot research your codebase and generate perfect OpenAPI-compliant documentation.',
        features: ['Codebase Analysis', 'OpenAPI Schema Generation', 'Usage Examples'],
        comparison: 'Vs Manual: 10x faster, 0 errors.'
    },
    'technical-blogging': {
        title: 'InkSpot for Technical Blogging',
        heroTitle: 'Deep Tech Blogs in Minutes',
        description: 'Write authoritative technical articles without staring at a blank screen. Research complex topics instantly.',
        features: ['Fact Checking', 'Code Snippet Generation', 'SEO Optimization'],
        comparison: 'Vs ChatGPT: More accurate, less hallucination.'
    },
    'inkspot-vs-jasper': {
        title: 'InkSpot vs Jasper',
        heroTitle: 'Why Developers Choose InkSpot',
        description: 'Jasper is for marketers. InkSpot is for builders. See why technical teams are switching.',
        features: ['Markdown Support', 'Code Highlighting', 'No Fluff'],
        comparison: 'Cost: InkSpot is 50% cheaper.'
    },
    'inkspot-vs-copyai': {
        title: 'InkSpot vs Copy.ai',
        heroTitle: 'The Technical Alternative to Copy.ai',
        description: 'Don\'t settle for generic marketing copy. Get technical precision with InkSpot.',
        features: ['Technical Context', 'Glossary Management', 'API Access'],
        comparison: 'Focus: Copy.ai is generic, InkSpot is specific.'
    },
    'laravel-documentation': {
        title: 'InkSpot for Laravel',
        heroTitle: 'Document Your Laravel Packages',
        description: 'Specifically trained on Laravel best practices. Generate Service Provider and Facade documentation effortlessly.',
        features: ['Laravel Syntax', 'Artisan Command Docs', 'Package Discovery'],
        comparison: 'Vs Standard AI: Understands Service Container.'
    },
    'react-component-docs': {
        title: 'InkSpot for React',
        heroTitle: 'Storybook-Ready Component Docs',
        description: 'Turn your tailored React components into beautiful documentation. Parses props and generate usage examples.',
        features: ['Prop Table Gen', 'Storybook Integration', 'TypeScript Support'],
        comparison: 'Vs Manual: Automated prop extraction.'
    },
    'python-generated-docs': {
        title: 'InkSpot for Python',
        heroTitle: 'Docstrings to Full Documentation',
        description: 'Convert your Python docstrings into a full developer portal. Supports Sphinx and MkDocs formats.',
        features: ['Sphinx Compatible', 'Type Hinting', 'Google Style Guide'],
        comparison: 'Vs AutoDoc: Adds context and tutorials.'
    },
    'release-notes-generator': {
        title: 'InkSpot for Release Notes',
        heroTitle: 'Turn Git Commits into Release Notes',
        description: 'Point InkSpot at your repo and get user-friendly release notes instantly.',
        features: ['Commit Analysis', 'User-Friendly Tone', 'Categorization'],
        comparison: 'Vs Manual: No missed features.'
    },
    'newsletter-writing': {
        title: 'InkSpot for Newsletters',
        heroTitle: 'Curate Technical Newsletters',
        description: 'Find the latest dev news and summarize it for your subscribers.',
        features: ['News Aggregation', 'Summary Generation', 'Link Curation'],
        comparison: 'Vs Feedly: Generates the commentary for you.'
    },
    'whitepaper-drafting': {
        title: 'InkSpot for Whitepapers',
        heroTitle: 'Draft Technical Whitepapers',
        description: 'Structure and draft long-form technical whitepapers with proper citations.',
        features: ['Citation Management', 'Deep Research', 'Formal Tone'],
        comparison: 'Vs Freelancers: Instant draft, 1/100th the cost.'
    }
}
